import { Tabs } from 'antd';
import React from 'react';
import { CodeSample } from '../samples/CodeSample';
import { Environment } from '../../../interfaces/backend/Environments';
import { Notification } from '../../../interfaces/backend/Notification';
import { User } from '../../../interfaces/backend/User';

interface CodeSampleTabsProps {
  environment?: Environment;
  notification?: Notification;
  user?: User;
  codeSamples: CodeSample[];
  mergeTags: Record<string, unknown>;
}

const CodeSampleTabs: React.FC<CodeSampleTabsProps> = ({
  environment,
  notification,
  user,
  codeSamples,
  mergeTags
}) => {
  const items = codeSamples.map((codeSample) => {
    return {
      key: codeSample.name,
      label: codeSample.name,
      children: (
        <>
          {codeSample.renderCode({
            environment,
            notification,
            user,
            mergeTags
          })}
        </>
      )
    };
  });

  return (
    <Tabs
      tabBarStyle={{
        margin: 0
      }}
      style={{
        width: '100%'
      }}
      animated={false}
      size="small"
      items={items}
    />
  );
};

export default CodeSampleTabs;
